// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 842) return "static/css/842.f7248e91244acdae709e.lib.css";
	if (chunkId === 689) return "static/css/689.45e8cd80316deed6929a.css";
	// return url for filenames based on template
	return undefined;
};